enum FeatureFlags {
  CART_MAINTENANCE_BANNER = 'cart-maintenance-banner',
  CLOUD_MIGRATION_TRIAL_LINK = 'cloud_migration_trial_cta_enabled',
  CART_ENABLE_OMNI_CHANNEL_CHAT = 'cart-enable-omni-channel-chat',
  CART_MAPPING_PARENT_APP_CSV = 'cart_mapping-parent-app-csv',
  CART_SITE_CONFIGURATOR_CLEANUP = 'cart-site-configurator-cleanup',
}

export default FeatureFlags;
